module.exports = __webpack_public_path__ + "images/category_lp/bike/new/assessment_achievements/4_6fe728ac7d15035df3683d71e458ab01.png";